<template>
  <div>
    <h1>Corporate Onboarding Guided Care Near You</h1>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CorporateOnboardingGuidedCareNearYou',
};
</script>